import { render, staticRenderFns } from "./addEvent.vue?vue&type=template&id=0ec68c24&"
import script from "./addEvent.vue?vue&type=script&lang=ts&"
export * from "./addEvent.vue?vue&type=script&lang=ts&"
import style0 from "./addEvent.vue?vue&type=style&index=0&id=0ec68c24&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports